module.exports = __webpack_public_path__ + "static/media/errorPayment.3ad44ea4.png";